<template>
	<v-container fluid class="pt-0">
		<v-row>
			<v-col cols="12" xl="12" lg="12" md="12" class="mb-8">
				<v-tabs>
					<v-tab>{{ $t('tabs.basicInfo') }}</v-tab>
					<v-tab>{{ $t('tabs.courseTeachers') }}</v-tab>
					<v-tab-item>
						<v-card flat outlined>
							<v-card-text>
								<v-row>
									<v-flex xs12 md4 lg4>
										<v-card-title class="pa-2">{{ $t('titles.courseInformations') }}</v-card-title>
									</v-flex>
									<v-flex class="d-flex justify-end">
										<v-btn
											v-if="inEditMode && $myStore.state.user.user_role_id == 1"
											class="ml-2 mr-2"
											color="primary"
											@click="saveClick(null)"
										>
											<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
										</v-btn>
										<v-btn
											v-if="!inEditMode && $myStore.state.user.user_role_id == 1"
											class="ml-2 mr-2"
											color="primary"
											@click="editClick()"
										>
											<v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
										</v-btn>
										<v-btn class="mr-2" color="basicButton" @click="backClick">
											<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
										</v-btn>
									</v-flex>
								</v-row>
								<v-row wrap>
									<v-flex lg6 xs12 sm12 class="pt-0 pr-2">
										<v-col cols="12" v-if="inEditMode && $route.params.id != 0">
											<InputField
												:readonly="true"
												v-model="course.id"
												:label="'* ' + $t('fields.id')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="course.code"
												:errorBorder="!courseValidation.code"
												:label="'* ' + $t('fields.code')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="course.name"
												:errorBorder="!courseValidation.name"
												:label="'* ' + $t('fields.name')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<Dropdown
												:readonly="!inEditMode"
												v-model="course.department_id"
												:ajax="true"
												:data="'departments'"
												:errorBorder="!courseValidation.department_id"
												:label="'* ' + $t('fields.department')"
											></Dropdown>
										</v-col>
										<v-col cols="12">
											<Dropdown
												:readonly="!inEditMode"
												v-model="course.certificate_id"
												:ajax="true"
												:data="'certificates'"
												:errorBorder="!courseValidation.certificate_id"
												:label="$t('fields.certificate')"
											></Dropdown>
										</v-col>
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												v-model="course.students_limit"
												:errorBorder="!courseValidation.students_limit"
												:label="'* ' + $t('fields.studentsLimit')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												v-model="course.duration_hours"
												:errorBorder="!courseValidation.duration_hours"
												:label="$t('fields.durationHours')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												v-model="course.duration_days"
												:errorBorder="!courseValidation.duration_days"
												:label="'* ' + $t('fields.durationDays')"
											></NumberField>
										</v-col>

										<v-col cols="12">
											<TextArea
												:readonly="!inEditMode"
												v-model="course.prerequisites"
												:errorBorder="!courseValidation.prerequisites"
												:label="$t('fields.prerequisites')"
												rows="3"
											></TextArea>
										</v-col>
										<v-col cols="12">
											<TextArea
												:readonly="!inEditMode"
												v-model="course.description"
												:errorBorder="!courseValidation.description"
												:label="$t('fields.description')"
												rows="3"
											></TextArea>
										</v-col>
										<v-col cols="12">
											<TextArea
												:readonly="!inEditMode"
												v-model="course.note"
												:errorBorder="!courseValidation.note"
												:label="$t('fields.note')"
												rows="3"
											></TextArea>
										</v-col>
										<v-col cols="12">
											<CheckBox
												:readonly="!inEditMode"
												v-model="course.active"
												:label="$t('fields.active')"
											></CheckBox>
										</v-col>
									</v-flex>
									<v-flex lg6 xs12 sm12 class="pt-0">
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												v-model="course.price_neto"
												:precision="2"
												:errorBorder="!courseValidation.price_neto"
												:label="'*' + $t('fields.priceNeto')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<NumberField
												:disabled="true"
												v-model="course.price_bruto"
												:precision="2"
												:label="$t('fields.priceBruto')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												v-model="course.testimonial_amount"
												:precision="0"
												:errorBorder="!courseValidation.testimonial_amount"
												:label="$t('fields.testimonialAmount')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												v-model="course.testimonial_price"
												:precision="2"
												:errorBorder="!courseValidation.testimonial_price"
												:label="$t('fields.testimonialUnitPrice')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<NumberField
												:disabled="true"
												v-model="course.price"
												:precision="2"
												:errorBorder="!courseValidation.price"
												:label="$t('fields.communicatePrice')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<CheckBox
												:readonly="!inEditMode"
												v-model="course.vat_exists"
												:label="$t('fields.vat2')"
											></CheckBox>
										</v-col>
										<v-col cols="12">
											<v-card flat>
												<v-card-text class="pt-2 pa-0">
													<v-card-title class="pa-2 pl-0 pb-0">{{
														$t('titles.concessions')
													}}</v-card-title>
													<v-row>
														<v-col cols="5">
															<Dropdown2
																:disabled="!inEditMode"
																:readonly="!inEditMode"
																v-model="office"
																:ajax="true"
																:clearable="true"
																:data="'offices'"
																:errorBorder="!officeValidation"
																:label="'* ' + $t('fields.office')"
																@item-selected="handleOffice"
															></Dropdown2>
														</v-col>
														<v-col cols="5">
															<DatePicker
																:disabled="!inEditMode"
																:readonly="!inEditMode"
																v-model="concessionDate"
																:errorBorder="!concessionDateValidation"
																:date-label="'* ' + $t('fields.concessionValidityDate')"
															></DatePicker>
														</v-col>
														<v-col cols="2" class="d-flex align-center">
															<v-tooltip bottom>
																<template v-slot:activator="{ on, attrs }">
																	<v-btn
																		elevation="2"
																		small
																		:disabled="!inEditMode"
																		color="primary"
																		v-bind="attrs"
																		@click="addConcession"
																		v-on="on"
																	>
																		<v-icon small>fa-plus</v-icon>
																	</v-btn>
																</template>
																<span>{{ $t('tooltips.addConcession') }}</span>
															</v-tooltip>
														</v-col>
													</v-row>
													<v-container v-if="course.offices.length > 0" class="pa-0">
														<v-row
															v-for="(item, key) in course.offices"
															:key="key"
															no-gutters
														>
															<v-col cols="10" class="pb-1 pt-0">
																<v-card
																	:key="item.id"
																	outlined
																	:class="{ 'module-item': $vuetify.theme.dark }"
																>
																	<v-row no-gutters>
																		<v-col
																			cols="6"
																			class="pa-1 pl-2 d-flex align-center"
																		>
																			<div
																				:class="[
																					'text-subtitle-1',
																					'pa-2',
																					'pl-0',
																				]"
																			>
																				{{ item.officeName }}
																			</div>
																		</v-col>
																		<v-col
																			cols="6"
																			class="pa-1 pl-2 d-flex align-center"
																		>
																			<div
																				:class="[
																					'text-subtitle-1',
																					'pa-2',
																					'pl-1',
																				]"
																			>
																				{{ item.dateDisplay }}
																			</div>
																		</v-col>
																	</v-row>
																</v-card>
															</v-col>
															<v-col
																cols="1"
																v-if="inEditMode && !item.hasOwnProperty('exist')"
																class="pb-0 d-flex align-center"
															>
																<v-tooltip bottom>
																	<template v-slot:activator="{ on, attrs }">
																		<v-btn
																			icon
																			large
																			v-bind="attrs"
																			@click="
																				deleteClick(
																					item.course_id,
																					item.office_id
																				)
																			"
																			v-on="on"
																		>
																			<v-icon small>fa-trash</v-icon>
																		</v-btn>
																	</template>
																	<span>{{ $t('tooltips.delete') }}</span>
																</v-tooltip>
															</v-col>
															<v-col
																cols="1"
																v-if="inEditMode && item.hasOwnProperty('exist')"
																class="pb-0 d-flex align-center"
															>
																<v-tooltip bottom>
																	<template v-slot:activator="{ on, attrs }">
																		<v-btn
																			icon
																			large
																			v-bind="attrs"
																			@click="
																				deleteConcession(
																					item.course_id,
																					item.office_id
																				)
																			"
																			v-on="on"
																		>
																			<v-icon small>fa-trash</v-icon>
																		</v-btn>
																	</template>
																	<span>{{ $t('tooltips.delete') }}</span>
																</v-tooltip>
															</v-col>
														</v-row>
													</v-container>
												</v-card-text>
											</v-card>
										</v-col>
										<v-col cols="12">
											<v-card flat>
												<v-card-text class="pa-0">
													<v-card-title class="pa-2 pl-0 pb-0">{{
														$t('titles.modules')
													}}</v-card-title>
													<v-row>
														<v-col cols="10">
															<InputField
																:disabled="!inEditMode"
																:readonly="!inEditMode"
																v-model="moduleName"
																:errorBorder="!courseValidation.modules"
																:label="'* ' + $t('fields.module')"
																@keypress.native.enter="addModuleToArray"
															></InputField>
														</v-col>
														<v-col cols="2" class="d-flex align-center">
															<v-tooltip bottom>
																<template v-slot:activator="{ on, attrs }">
																	<v-btn
																		elevation="2"
																		small
																		:disabled="!inEditMode"
																		color="primary"
																		v-bind="attrs"
																		@click="addModuleToArray()"
																		v-on="on"
																	>
																		<v-icon small>fa-plus</v-icon>
																	</v-btn>
																</template>
																<span>{{ $t('tooltips.addModule') }}</span>
															</v-tooltip>
														</v-col>
													</v-row>
													<v-container
														v-if="course.modules.length > 0"
														class="overflow-container pa-0"
													>
														<v-row
															v-for="(item, key) in course.modules"
															:key="key"
															no-gutters
														>
															<v-col cols="10" class="pb-1 pt-0">
																<v-card
																	:key="item.id"
																	outlined
																	:class="{ 'module-item': $vuetify.theme.dark }"
																>
																	<div :class="['text-h8', 'pa-2']">
																		{{ item.name }}
																	</div>
																</v-card>
															</v-col>
															<v-col
																cols="2"
																v-if="inEditMode"
																class="pb-0 d-flex align-center"
															>
																<v-tooltip bottom>
																	<template v-slot:activator="{ on, attrs }">
																		<v-btn
																			icon
																			large
																			v-bind="attrs"
																			@click="deleteModule(item.name)"
																			v-on="on"
																		>
																			<v-icon small>fa-trash</v-icon>
																		</v-btn>
																	</template>
																	<span>{{ $t('tooltips.delete') }}</span>
																</v-tooltip>
															</v-col>
														</v-row>
													</v-container>
												</v-card-text>
											</v-card>
										</v-col>
									</v-flex>
								</v-row>
							</v-card-text>
						</v-card>
					</v-tab-item>
					<v-tab-item>
						<CourseTeachers></CourseTeachers>
					</v-tab-item>
				</v-tabs>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from '../../trinkets/InputField';
import CheckBox from '../../trinkets/CheckBox';
import Course from '../../../models/Course';
import NumberField from '../../trinkets/NumberField';
import Dropdown from '../../trinkets/Dropdown';
import Dropdown2 from '../../trinkets/Dropdown2';
import DatePicker from '../../trinkets/DatePicker';
import TextArea from '../../trinkets/TextArea';
import CourseTeachers from './CourseTeachers.vue';

export default {
	name: 'Course',
	components: { CheckBox, InputField, NumberField, DatePicker, Dropdown, Dropdown2, TextArea, CourseTeachers },
	data: function () {
		return {
			course: new Course({ id: this.$route.params.id }),
			courseValidation: new Course({}, true),
			initialLoad: false,
			inEditMode: false,
			lockKey: 'course',
			lockTimer: null,
			moduleName: '',
			moduleItem: {},
			office: null,
			officeDisplay: null,
			officeValidation: true,
			concessionDate: null,
			concessionDateDisplay: null,
			concessionDateValidation: true,
		};
	},
	watch: {
		'course.price_neto': function (newVal) {
			if (this.course.vat_exists) {
				this.course.price_bruto = parseFloat((newVal * 1.25).toFixed(2));
			} else {
				this.course.price_bruto = this.course.price_neto;
			}
			if (newVal != null) {
				this.course.price =
					this.course.price_bruto + this.course.testimonial_amount * this.course.testimonial_price;
			}
		},
		'course.testimonial_amount': function (newVal) {
			if (newVal != null) {
				this.course.price =
					this.course.price_bruto + this.course.testimonial_amount * this.course.testimonial_price;
			}
		},
		'course.testimonial_price': function (newVal) {
			if (newVal != null) {
				this.course.price =
					this.course.price_bruto + this.course.testimonial_amount * this.course.testimonial_price;
			}
		},
		'course.vat_exists': function (newVal) {
			if (newVal == false) {
				this.course.price_bruto = this.course.price_neto;
				this.course.price =
					this.course.price_bruto + this.course.testimonial_amount * this.course.testimonial_price;
			} else {
				this.course.price_bruto = parseFloat((this.course.price_neto * 1.25).toFixed(2));
				this.course.price =
					this.course.price_bruto + this.course.testimonial_amount * this.course.testimonial_price;
			}
		},
	},
	methods: {
		editClick() {
			let vm = this;
			this.$setLock(this, this.lockKey + '|' + this.course.id, (data) => {
				if (data.success) {
					vm.inEditMode = true;
					vm.lockTimer = setInterval(() => {
						vm.$setLock(vm, vm.lockKey + '|' + vm.course.id);
					}, 10000);
				} else {
					vm.$alert(
						vm
							.$t('alerts.recordLocked')
							.split('%name%')
							.join(data.locked_by.first_name + ' ' + data.locked_by.last_name)
					);
				}
			});
		},
		addConcession() {
			let success = true;

			if (this.concessionDate == null) {
				success = false;
				this.concessionDateValidation = false;
			} else {
				this.concessionDateValidation = true;
			}

			if (this.office == null) {
				success = false;
				this.officeValidation = false;
			} else {
				this.officeValidation = true;
			}

			if (success) {
				if (this.concessionExists(this.office)) {
					this.$alert(this.$t('alerts.officeConcessionExists'));
				} else {
					this.concessionDateDisplay = this.concessionDate.split('-').reverse().join('.');

					this.course.offices.push({
						course_id: this.$route.params.id,
						office_id: this.office,
						date: this.concessionDate,
						dateDisplay: this.concessionDateDisplay,
						officeName: this.officeDisplay,
					});
					this.officeDisplay = null;
					this.office = null;
					this.concessionDate = null;
					this.concessionDateDisplay = null;
				}
			}
		},
		handleOffice(item) {
			this.officeDisplay = item.name;
		},
		concessionExists(office) {
			return this.course.offices.some((item) => item.office_id === office);
		},
		deleteClick(course_id, office_id) {
			this.course.offices = this.course.offices.filter(
				(item) => item.course_id !== course_id || item.office_id !== office_id
			);
		},
		deleteConcession(course_id, office_id) {
			let vm = this;
			this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
				if (result) {
					this.course.offices = this.course.offices.filter(
						(item) => item.course_id !== course_id || item.office_id !== office_id
					);
					vm.$APICall(
						'delete',
						'course-office/' + course_id + '/' + office_id + '/delete',
						{ course_id: course_id, office_id: office_id },
						(data, success) => {
							if (success) {
								vm.$notify(vm.$t('alerts.basicDelete'));
							} else {
								vm.$alert(vm.$t('alerts.basicError'));
							}
						}
					);
				}
			});
		},

		backClick() {
			this.$router.go(-1);
		},
		addModuleToArray() {
			if (this.moduleName != '') {
				this.moduleItem.name = this.moduleName;
				this.course.modules.push(this.moduleItem);
				this.moduleName = '';
				this.moduleItem = {};
			}
		},
		deleteModule(moduleName) {
			this.course.modules = this.course.modules.filter((item) => item.name !== moduleName);
		},
		saveClick(after = null) {
			let success = true;
			let errorMessages = '';

			if (!this.course.modules.length) {
				success = false;
				this.courseValidation.modules = false;
				errorMessages += this.$t('alerts.courseModuleError') + '<br />';
			} else {
				this.courseValidation.modules = true;
			}

			if (this.course.code == null || this.course.code == '') {
				success = false;
				this.courseValidation.code = false;
			} else {
				if (this.course.code.length > 50) {
					this.courseValidation.code = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.code'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.courseValidation.code = true;
				}
			}

			if (this.course.name == null || this.course.name == '') {
				success = false;
				this.courseValidation.name = false;
			} else {
				if (this.course.name.length > 254) {
					this.courseValidation.name = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.name'))
							.replace('%length%', '254') + '<br />';
				} else {
					this.courseValidation.name = true;
				}
			}

			if (!this.course.department_id) {
				success = false;
				this.courseValidation.department_id = false;
			} else {
				this.courseValidation.department_id = true;
			}

			if (!this.course.students_limit) {
				success = false;
				this.courseValidation.students_limit = false;
			} else {
				if (this.course.students_limit < 1 || this.course.students_limit > 100) {
					this.courseValidation.students_limit = false;
					errorMessages +=
						this.$t('alerts.valueError')
							.replace('%field%', this.$t('fields.studentsLimit'))
							.replace('%min%', '1')
							.replace('%max%', '100') + '<br />';
				} else {
					this.courseValidation.students_limit = true;
				}
			}

			if (this.course.duration_hours && (this.course.duration_hours < 1 || this.course.duration_hours > 1000)) {
				this.courseValidation.duration_hours = false;
				errorMessages +=
					this.$t('alerts.valueError')
						.replace('%field%', this.$t('fields.durationHours'))
						.replace('%min%', '1')
						.replace('%max%', '1000') + '<br />';
			} else {
				this.courseValidation.duration_hours = true;
			}

			if (!this.course.duration_days) {
				success = false;
				this.courseValidation.duration_days = false;
			} else {
				if (this.course.duration_days < 1 || this.course.duration_days > 100) {
					this.courseValidation.duration_days = false;
					errorMessages +=
						this.$t('alerts.valueError')
							.replace('%field%', this.$t('fields.durationDays'))
							.replace('%min%', '1')
							.replace('%max%', '100') + '<br />';
				} else {
					this.courseValidation.duration_days = true;
				}
			}

			if (this.course.prerequisites != null && this.course.prerequisites.length > 500) {
				this.courseValidation.prerequisites = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.prerequisites'))
						.replace('%length%', '500') + '<br />';
			} else {
				this.courseValidation.prerequisites = true;
			}

			if (this.course.description != null && this.course.description.length > 500) {
				this.courseValidation.description = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.description'))
						.replace('%length%', '500') + '<br />';
			} else {
				this.courseValidation.description = true;
			}

			if (this.course.note != null && this.course.note.length > 500) {
				this.courseValidation.note = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.note'))
						.replace('%length%', '500') + '<br />';
			} else {
				this.courseValidation.note = true;
			}

			if (this.course.price_neto == null || this.course.price_net < 0) {
				success = false;
				this.courseValidation.price_neto = false;
			} else {
				this.courseValidation.price_neto = true;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.course.id != 0) {
					action = 'put';
					addition = '/' + vm.course.id;
				}

				this.$APICall(action, 'courses' + addition, this.course, (data, success) => {
					if (success) {
						vm.inEditMode = false;
						if (vm.course.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						if (after !== null) {
							after();
						} else {
							vm.backClick();
						}
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
	},
	beforeRouteLeave(to, from, next) {
		let vm = this;
		if (this.inEditMode) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				if (result) {
					if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
					vm.$removeLock(vm, vm.lockKey + '|' + vm.course.id);
					next(true);
				} else {
					next(false);
				}
			});
		} else {
			if (this.lockTimer !== null) clearInterval(this.lockTimer);
			vm.$removeLock(vm, vm.lockKey + '|' + vm.course.id);
			next(true);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		let vm = this;
		if (this.course.id != 0) {
			this.$APICall('get', 'courses/' + this.course.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.course = usableData;
					vm.$myStore.commit('setBreadcrumbs', [
						{
							text: vm.$t('modules.courses'),
							href: '/#/courses',
							disabled: false,
						},
						{
							text: vm.course.name + ' (' + vm.course.id + ')',
							href: '/#/courses/' + vm.course.id,
							disabled: true,
						},
					]);
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
				}
			});
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{
					text: this.$t('modules.courses'),
					href: '/#/courses',
					disabled: false,
				},
				{
					text: this.$t('modules.newCourse'),
					href: '/#/courses/0',
					disabled: true,
				},
			]);
			this.inEditMode = true;
			this.initialLoad = true;
		}
	},
};
</script>

<style scoped>
.module-item {
	background: #444;
}

.overflow-container {
	max-height: 350px;
	overflow-y: auto;
}
</style>
